import VueTheMask from 'vue-the-mask'

export const inputMaskPlugin = VueTheMask
